import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/commerce-pwa-studio/commerce-pwa-studio/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`An ECMAScript module containing a React component with JSX to render it.`}</p>
    <p>{`Presents a convenient API for consumers to add common transforms to React
components and the JSX in them, in a semantic way.`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "#TargetableReactComponent"
        }}>{`TargetableReactComponent`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableReactComponent+addJSXClassName"
            }}>{`.addJSXClassName(element, className, [options])`}</a>{` ⇒ `}<inlineCode parentName="li">{`this`}</inlineCode></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableReactComponent+addReactLazyImport"
            }}>{`.addReactLazyImport(modulePath, [localName])`}</a>{` ⇒ `}<inlineCode parentName="li">{`string`}</inlineCode></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableReactComponent+appendJSX"
            }}>{`.appendJSX(element, newChild, [options])`}</a>{` ⇒ `}<inlineCode parentName="li">{`this`}</inlineCode></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableReactComponent+insertAfterJSX"
            }}>{`.insertAfterJSX(element, newSibling, [options])`}</a>{` ⇒ `}<inlineCode parentName="li">{`this`}</inlineCode></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableReactComponent+insertBeforeJSX"
            }}>{`.insertBeforeJSX(element, newSibling, [options])`}</a>{` ⇒ `}<inlineCode parentName="li">{`this`}</inlineCode></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableReactComponent+prependJSX"
            }}>{`.prependJSX(element, newChild, [options])`}</a>{` ⇒ `}<inlineCode parentName="li">{`this`}</inlineCode></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableReactComponent+removeJSX"
            }}>{`.removeJSX(element, [options])`}</a>{` ⇒ `}<inlineCode parentName="li">{`this`}</inlineCode></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableReactComponent+removeJSXProps"
            }}>{`.removeJSXProps(element, propNames, [options])`}</a>{` ⇒ `}<inlineCode parentName="li">{`this`}</inlineCode></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableReactComponent+replaceJSX"
            }}>{`.replaceJSX(jsx, replacement, [options])`}</a>{` ⇒ `}<inlineCode parentName="li">{`this`}</inlineCode></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableReactComponent+setJSXProps"
            }}>{`.setJSXProps(element, props, [options])`}</a>{` ⇒ `}<inlineCode parentName="li">{`this`}</inlineCode></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "#TargetableReactComponent+surroundJSX"
            }}>{`.surroundJSX(element, newParent, [options])`}</a>{` ⇒ `}<inlineCode parentName="li">{`this`}</inlineCode></li>
        </ul>
      </li>
    </ul>
    <p>{`Add a CSS classname to a JSX element. Unlike setting the className prop,
this is non-destructive. It will append the classname to any existing
classnames, instead of replacing it.`}</p>
    <p><strong parentName="p">{`Chainable`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`element`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Match an existing JSX component in the file`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`className`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`New classname to insert. This will be interpolated; to add a string literal classname, set this to '"classname"'. Passing 'classname' will add the value of a local variable `}<inlineCode parentName="td">{`classname`}</inlineCode>{` in the file. If that identifier doesn't exist, it'll cause a ReferenceError.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`JSXModifierOptions`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <p>{`Add a new named dynamic import of another React component, using the `}<inlineCode parentName="p">{`lazy`}</inlineCode>{`
wrapper for use with React.Suspense.`}</p>
    <p><strong parentName="p">{`Returns:`}</strong>{`
`}<inlineCode parentName="p">{`string`}</inlineCode>{`
— Name of the local binding of the element, to be used in JSX operations.`}</p>
    <p><strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Default`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`modulePath`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode></inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Resolvable path to the module to import.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[localName]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode>{`Component`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Optional human-readable name for debugging.`}</td>
        </tr>
      </tbody>
    </table>
    <p>{`Append a JSX element to the children of `}<inlineCode parentName="p">{`element`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`Chainable`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`element`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Match an existing JSX component in the file`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`newChild`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`New element to insert, as a string.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`JSXModifierOptions`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <p>{`Insert a JSX element `}<em parentName="p">{`after`}</em>{` `}<inlineCode parentName="p">{`element`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`Chainable`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`element`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Match an existing JSX component in the file`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`newSibling`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`New element to insert, as a string.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`JSXModifierOptions`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <p>{`Insert a JSX element `}<em parentName="p">{`before`}</em>{` `}<inlineCode parentName="p">{`element`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`Chainable`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`element`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Match an existing JSX component in the file`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`newSibling`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`New element to insert, as a string.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`JSXModifierOptions`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <p>{`Prepend a JSX element to the children of `}<inlineCode parentName="p">{`element`}</inlineCode>{`.`}</p>
    <p><strong parentName="p">{`Chainable`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`element`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Match an existing JSX component in the file`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`newChild`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`New element to insert, as a string.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`JSXModifierOptions`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <p>{`Remove the JSX node matched by 'element'.`}</p>
    <p><strong parentName="p">{`Chainable`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`element`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Match an existing JSX component in the file and remove it`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`JSXModifierOptions`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <p>{`Remove JSX props from the element if they match one of the list of names.`}</p>
    <p><strong parentName="p">{`Chainable`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`element`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Match an existing JSX component in the file.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`propNames`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Array.<string>`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`An array of names of props to remove.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`JSXModifierOptions`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <p>{`Replace a JSX element with different code.`}</p>
    <p><strong parentName="p">{`Chainable`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`jsx`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A JSX element matching the one in the source code to modify. Use a JSX opening element or a self-closing element, like `}<inlineCode parentName="td">{`<Route path="/">`}</inlineCode>{`.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`replacement`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Replacement code as a string.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`JSXModifierOptions`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <p>{`Set JSX props on a JSX element.`}</p>
    <p><strong parentName="p">{`Chainable`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`element`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Match an existing JSX component in the file.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`props`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A simple object representing the props. Keys should be prop names, and values should be raw strings representing the value in JSX text.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`JSXModifierOptions`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Example`}</strong>{`  `}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`file.setJSXProps('Tab colorScheme="dark"', {
  colorScheme: '"light"',
  className: '{classes.tabs}'
})
`}</code></pre>
    <p>{`Wrap a JSX element in an outer element.`}</p>
    <p><strong parentName="p">{`Chainable`}</strong><br parentName="p"></br>{`
`}<strong parentName="p">{`Returns:`}</strong>{`
`}<strong parentName="p">{`Parameters`}</strong></p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Name`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`element`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Match an existing JSX component in the file.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`newParent`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`string`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The wrapper element as a JSX string. It must be one and only one JSX element with no children; the matching element will be the only child of the new wrapper.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`[options]`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`JSXModifierOptions`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}></td>
        </tr>
      </tbody>
    </table>
    <p><strong parentName="p">{`Source Code`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://github.com/magento/pwa-studio/blob/develop/packages/pwa-buildpack/lib/WebpackTools/targetables/TargetableReactComponent.js"
      }}>{`pwa-studio/packages/pwa-buildpack/lib/WebpackTools/targetables/TargetableReactComponent.js`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      